import api from './axios';

export const listEmpresas = () => api.get('/empresas/');
export const getEmpresa = (id) => api.get(`/empresas/${id}`);
export const createEmpresa = (data) => api.post('/empresas/', data);
export const updateEmpresa = (id, data) => api.patch(`/empresas/${id}`, data);
